// components/TradeButton.jsx

import React, { useState } from "react";
import { useTrading } from "../../hooks/useTrading";
import "./TradeButton.css";

const TradeButton = ({ securityId, symbol, lastPrice }) => {
  const { buy, sell, loading, error, result } = useTrading();
  const [qty, setQty] = useState(2);
  const [bought, setBought] = useState(false);

  const handleBuy = async () => {
    const res = await buy(securityId, qty, lastPrice);
    if (res?.success) setBought(true);
  };

  const handleSell = async () => {
    const res = await sell(securityId, qty);
    if (res?.success) setBought(false);
  };

  return (
    <div className="trade-card">
      <div className="trade-header">
        <h3>Trade {symbol}</h3>
        <span className="trade-badge">MTF</span>
      </div>

      <div className="trade-info-row">
        <div className="trade-info-item">
          <span className="trade-label">Price</span>
          <h2 className="trade-price">₹{lastPrice || "—"}</h2>
        </div>

        <div className="trade-info-item">
          <span className="trade-label">Qty</span>
          <input
            type="number"
            min="1"
            value={qty}
            onChange={(e) => setQty(Number(e.target.value))}
            className="trade-qty-input"
          />
        </div>

        <div className="trade-info-item">
          <span className="trade-label">Total</span>
          <b className="trade-total">
            ₹{lastPrice ? (lastPrice * qty).toFixed(2) : "—"}
          </b>
        </div>
      </div>

      {!bought ? (
        <button
          onClick={handleBuy}
          disabled={loading || !lastPrice}
          className="trade-buy-btn"
        >
          {loading ? "Placing..." : `BUY ${qty} × ${symbol} @ ₹${lastPrice}`}
        </button>
      ) : (
        <button
          onClick={handleSell}
          disabled={loading}
          className="trade-sell-btn"
        >
          {loading ? "Selling..." : `SELL ${qty} × ${symbol}`}
        </button>
      )}

      {result && (
        <p
          className={`trade-result ${result.success ? "trade-result-success" : "trade-result-error"}`}
        >
          {result.success
            ? `Order placed — ID: ${result.data?.orderId || result.orderId}`
            : `Failed: ${JSON.stringify(result.error)}`}
        </p>
      )}

      {error && <p className="trade-result trade-result-error">{error}</p>}
    </div>
  );
};

export default TradeButton;
